module.exports = __webpack_public_path__ + "img/plus.fe8a9106.png";